var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { ScheduledShiftStatusType } from '../useScheduledShiftStatus';
import { gql } from '@apollo/client';
export var WorkedShiftStatusType;
(function (WorkedShiftStatusType) {
    WorkedShiftStatusType["none"] = "none";
    WorkedShiftStatusType["hasTimeOff"] = "hasTimeOff";
    WorkedShiftStatusType["vtoAccepted"] = "vtoAccepted";
})(WorkedShiftStatusType || (WorkedShiftStatusType = {}));
export var useWorkedShiftStatus = function (_a) {
    var _b;
    var _c;
    var scheduleShift = _a.scheduleShift, timeoffEntries = _a.timeoffEntries;
    var statusMap = (_b = {},
        _b[WorkedShiftStatusType.none] = false,
        _b[WorkedShiftStatusType.hasTimeOff] = false,
        _b[WorkedShiftStatusType.vtoAccepted] = false,
        _b);
    if (!!((_c = scheduleShift.acceptedVtoTimeRanges) === null || _c === void 0 ? void 0 : _c.length)) {
        statusMap[ScheduledShiftStatusType.vtoAccepted] = true;
    }
    if (timeoffEntries.length) {
        statusMap[ScheduledShiftStatusType.hasTimeOff] = true;
    }
    var allStatusesAreFalse = Object.values(statusMap).every(function (isVisible) { return !isVisible; });
    if (allStatusesAreFalse) {
        statusMap[ScheduledShiftStatusType.none] = true;
    }
    return statusMap;
};
useWorkedShiftStatus.fragments = {
    shift: gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        fragment UseWorkedShiftStatus_Shift on Shift {\n            id\n            timeRange {\n                start\n                end\n            }\n        }\n    "], ["\n        fragment UseWorkedShiftStatus_Shift on Shift {\n            id\n            timeRange {\n                start\n                end\n            }\n        }\n    "]))),
    scheduleShift: gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        fragment UseWorkedShiftStatus_ScheduleShift on ScheduleShift {\n            shift {\n                ...UseWorkedShiftStatus_Shift\n            }\n            acceptedVtoTimeRanges {\n                start\n                end\n            }\n        }\n    "], ["\n        fragment UseWorkedShiftStatus_ScheduleShift on ScheduleShift {\n            shift {\n                ...UseWorkedShiftStatus_Shift\n            }\n            acceptedVtoTimeRanges {\n                start\n                end\n            }\n        }\n    "])))
};
var templateObject_1, templateObject_2;
